import { useEffect, useMemo } from "react";

const APPLE_URL = "https://apps.apple.com/us/app/pay2pee/id6761129194";
const GOOGLE_URL =
  "https://play.google.com/store/apps/details?id=com.yourname.pay2pee&pcampaignid=web_share";

export default function DownloadPage() {
  const deviceType = useMemo(() => {
    if (typeof window === "undefined") return "desktop";

    const ua = navigator.userAgent || navigator.vendor || window.opera || "";
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);

    if (isIOS) return "ios";
    if (isAndroid) return "android";
    return "desktop";
  }, []);

  useEffect(() => {
    if (deviceType === "desktop") return;

    const timeout = setTimeout(() => {
      if (deviceType === "ios") {
        window.location.href = APPLE_URL;
      } else if (deviceType === "android") {
        window.location.href = GOOGLE_URL;
      }
    }, 1200);

    return () => clearTimeout(timeout);
  }, [deviceType]);

  const redirectText =
    deviceType === "ios"
      ? "Redirecting you to the App Store..."
      : deviceType === "android"
      ? "Redirecting you to Google Play..."
      : "Available now on iPhone and Android";

  return (
    <div style={container}>
      <img src="/images/logo.png" alt="Pay2Pee" style={logo} />

      <h1 style={headline}>Find a bathroom fast.</h1>

      <div style={badgeRow}>
        <a href={APPLE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="/assets/app-store-badge.svg"
            alt="Download on the App Store"
            style={badge}
          />
        </a>

        <a href={GOOGLE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="/assets/google-play-badge.png"
            alt="Get it on Google Play"
            style={badge}
          />
        </a>
      </div>

      <p style={subtext}>{redirectText}</p>
    </div>
  );
}

/* STYLES */

const container = {
  minHeight: "100vh",
  background: "#0a0a0a",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "20px",
};

const logo = {
  width: "140px",
  marginBottom: "20px",
};

const headline = {
  color: "#fff",
  fontSize: "28px",
  fontWeight: "700",
  marginBottom: "25px",
};

const badgeRow = {
  display: "flex",
  gap: "15px",
  flexWrap: "wrap",
  justifyContent: "center",
};

const badge = {
  height: "55px",
};

const subtext = {
  marginTop: "20px",
  color: "#aaa",
  fontSize: "14px",
};